var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLicenseManagement = function SvgLicenseManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 179
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__a",
    x1: "50.001%",
    x2: "50.001%",
    y1: "100.002%",
    y2: ".002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__b",
    x1: "50.028%",
    x2: "50.028%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__c",
    x1: "50.009%",
    x2: "50.009%",
    y1: "100.003%",
    y2: "-.015%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__d",
    x1: "49.975%",
    x2: "49.975%",
    y1: "100.003%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__e",
    x1: "49.993%",
    x2: "49.993%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__f",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__g",
    x1: "49.995%",
    x2: "49.995%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__h",
    x1: "49.999%",
    x2: "49.999%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__i",
    x1: "49.996%",
    x2: "49.996%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__j",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__k",
    x1: "50.003%",
    x2: "50.003%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__l",
    x1: "0%",
    x2: "100%",
    y1: "50.004%",
    y2: "50.004%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__m",
    x1: "50.009%",
    x2: "50.009%",
    y1: "99.978%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__n",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__o",
    x1: "49.971%",
    x2: "49.971%",
    y1: "99.974%",
    y2: ".001%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__p",
    x1: "49.947%",
    x2: "49.947%",
    y1: "100.006%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__q",
    x1: "49.993%",
    x2: "49.993%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__r",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__s",
    x1: "49.995%",
    x2: "49.995%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__t",
    x1: "49.999%",
    x2: "49.999%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__u",
    x1: "49.996%",
    x2: "49.996%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__v",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__w",
    x1: "50.003%",
    x2: "50.003%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "license-management_svg__x",
    x1: "0%",
    x2: "100%",
    y1: "50.004%",
    y2: "50.004%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.407 57.466a23.921 23.921 0 0 0 5.658-18.975 23.876 23.876 0 0 0-10.571-16.728 14.15 14.15 0 0 0 2.253-7.687c0-7.71-6.094-13.962-13.611-13.962-6.191 0-11.41 4.246-13.06 10.051C62.524 4.141 56.076.114 48.71.114c-11.203 0-20.283 9.315-20.283 20.807a21.252 21.252 0 0 0 1.242 7.182 15.577 15.577 0 0 0-1.242-.064c-8.992 0-16.293 7.479-16.293 16.703 0 .567.028 1.13.083 1.686C4.744 49.794-.047 57.265 0 65.482c0 11.454 9.052 20.74 20.217 20.74 1.173 0 2.344-.106 3.499-.315-.061.69-.097 1.385-.097 2.097 0 12.852 10.157 23.267 22.686 23.267 4.632 0 9.149-1.454 12.918-4.155a16.62 16.62 0 0 0 10.969 4.155c9.358 0 16.947-7.784 16.947-17.387 0-.415-.033-.83-.06-1.232h.06c10.024 0 18.149-8.335 18.149-18.616a18.674 18.674 0 0 0-9.881-16.57z",
    fill: "url(#license-management_svg__a)",
    transform: "matrix(-1 0 0 1 300 .561)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303854",
    d: "M207.214 57.916a22.45 22.45 0 0 1-5.313-17.812 22.413 22.413 0 0 1 9.925-15.703 13.284 13.284 0 0 1-2.116-7.201c0-7.238 5.72-13.107 12.778-13.107 5.799 0 10.709 3.985 12.258 9.434a18.935 18.935 0 0 1 16.293-9.434c10.516 0 19.04 8.744 19.04 19.53a19.934 19.934 0 0 1-1.165 6.742c.387-.03.773-.061 1.165-.061 8.45-.003 15.285 7.013 15.285 15.683 0 .534-.028 1.06-.077 1.581 7.018 3.157 11.519 10.17 11.477 17.885 0 10.753-8.498 19.467-18.977 19.467-1.101-.002-2.2-.1-3.284-.297.055.649.091 1.305.091 1.967 0 12.063-9.532 21.843-21.294 21.843a20.815 20.815 0 0 1-12.125-3.878 15.596 15.596 0 0 1-10.295 3.878c-8.784 0-15.909-7.307-15.909-16.32 0-.39.03-.773.058-1.158h-.058c-9.408 0-17.036-7.825-17.036-17.475a17.526 17.526 0 0 1 9.279-15.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__b)",
    d: "M54.247 32.988h4.946v123.4h-4.946z",
    transform: "matrix(-1 0 0 1 300 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "M244.348 34.722h-2.488v121.666h2.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "m244.574 70.574-20.416-22.113-1.825 1.695 20.414 22.114zM265.571 75.67l-1.483-2.004-21.169 15.769 1.484 2.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.837 48.196a19.287 19.287 0 0 1-5.208-13.163c0-7.046 3.819-13.223 9.557-16.705a11.387 11.387 0 0 1-1.983-6.418C11.203 5.46 16.6.23 23.257.23c5.485 0 10.105 3.55 11.565 8.41A18.07 18.07 0 0 1 50.202.23c9.921 0 17.949 7.794 17.949 17.408 0 2.054-.375 4.09-1.105 6.008.365-.027.73-.052 1.105-.052 7.964 0 14.418 6.254 14.418 13.97-.001.472-.026.942-.075 1.41 6.368 2.66 10.828 8.795 10.828 15.941 0 9.584-8.009 17.35-17.906 17.35a18.496 18.496 0 0 1-3.098-.276c.052.579.086 1.16.086 1.753 0 10.753-8.995 19.47-20.09 19.47a20.437 20.437 0 0 1-11.425-3.469 15.214 15.214 0 0 1-9.715 3.468c-8.284 0-15.008-6.512-15.008-14.544 0-.35.027-.69.052-1.033h-.052C7.29 77.634.094 70.659.094 62.059c0-6.044 3.56-11.282 8.743-13.863z",
    fill: "url(#license-management_svg__c)",
    transform: "matrix(-1 0 0 1 244.494 23.55)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101938",
    d: "M234.025 71.683a18.455 18.455 0 0 0 4.97-12.6c0-6.745-3.655-12.656-9.148-15.988a10.874 10.874 0 0 0 1.908-6.155c0-6.174-5.166-11.182-11.537-11.182-5.247 0-9.665 3.399-11.071 8.05a17.302 17.302 0 0 0-14.705-8.041c-9.497 0-17.193 7.459-17.193 16.66a16.173 16.173 0 0 0 1.052 5.753c-.348-.025-.696-.052-1.052-.052-7.622 0-13.807 5.988-13.807 13.373 0 .45.022.9.069 1.349-6.095 2.545-10.364 8.417-10.364 15.256 0 9.17 7.671 16.62 17.138 16.62a17.847 17.847 0 0 0 2.963-.267c-.05.554-.08 1.108-.08 1.679 0 10.293 8.61 18.635 19.228 18.635a19.557 19.557 0 0 0 10.95-3.324 14.56 14.56 0 0 0 9.297 3.324c7.934 0 14.36-6.232 14.36-13.921 0-.332-.028-.66-.053-.989h.053c8.497 0 15.384-6.675 15.384-14.907.014-5.79-3.391-10.803-8.362-13.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "M201.429 52.191v103.573"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__d)",
    d: "M95.666 52.191h5.625v103.571h-5.625z",
    transform: "matrix(-1 0 0 1 300 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "M202.983 52.191h-3.109v103.571h3.109zm-1.869 31.02 18.438-18.866"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "m220.665 65.437-2.221-2.182-18.438 18.865 2.22 2.183zM201.114 99.426l-19.115-13.454M202.007 98.145 182.892 84.69l-1.785 2.553 19.113 13.455z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 235.373 1.323)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__e)",
    d: "M159.94 69.039H21.255c-3.167 0-5.733 1.429-5.733 3.196v102.12h150.16V72.234c0-1.767-2.575-3.196-5.742-3.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M90.16 10.606 17.812 64.507V170.46h145.13V68.352z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.303,
    cy: 59.225,
    fill: "url(#license-management_svg__f)",
    rx: 16.111,
    ry: 16.159
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__g)",
    d: "M31.619 90.389h28.479v28.566H31.619zm88.315 0h28.479v28.566h-28.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__h)",
    d: "M3.858 91.391 0 69.748 90.477 0l89.564 71.141-2.485 19.42-87.092-65.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M1.381 72.091 90.455 2.374l88.205 69.723-2.67 14.94-85.548-67.623L4.035 87.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__i)",
    d: "M72.757 122.705h34.809v47.755H72.757z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M73.762 123.716h32.795v46.744H73.762zM32.914 91.397H59.38v9.379H32.914z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M32.914 100.776H59.38v17.168H32.914z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M120.942 91.397h26.466v9.379h-26.466z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M120.942 100.776h26.466v17.168h-26.466z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M90.16 73.797c3.893 0 7.627-1.552 10.38-4.315a14.746 14.746 0 0 0 4.292-10.415H75.488a14.736 14.736 0 0 0 4.292 10.415 14.65 14.65 0 0 0 10.38 4.315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M90.16 73.653c8.103 0 14.672-6.588 14.672-14.716H75.488c0 8.128 6.569 14.716 14.672 14.716z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M90.16 44.365c-8.098 0-14.664 6.58-14.672 14.702h29.344c-.008-8.122-6.574-14.702-14.672-14.702z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M90.16 44.365c-8.098 0-14.664 6.58-14.672 14.702h29.344c-.008-8.122-6.574-14.702-14.672-14.702z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.933,
    cy: 146.944,
    fill: "url(#license-management_svg__j)",
    rx: 3.452,
    ry: 3.462
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.933,
    cy: 146.944,
    fill: "#263238",
    rx: 2.59,
    ry: 2.598
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__k)",
    d: "M68.441 163.679h42.287v13.849H68.441z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M69.302 164.831h40.561v11.83H69.302z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__l)",
    d: "M131.162 39.235V20.843h16.293v34.089z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M133.096 40.509V24.444h12.15v30.488z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.054 26.693c2.09-2.4 3.04-5.59 2.607-8.745a11.012 11.012 0 0 0-4.871-7.71 6.526 6.526 0 0 0 1.038-3.543 6.27 6.27 0 0 0-5.35-6.368 6.256 6.256 0 0 0-6.944 4.565A9.297 9.297 0 0 0 22.525.258c-5.164 0-9.35 4.293-9.35 9.592a9.775 9.775 0 0 0 .572 3.323c-.19-.013-.379-.03-.572-.03-4.142 0-7.506 3.446-7.506 7.697 0 .264 0 .521.039.779a9.57 9.57 0 0 0-5.636 8.783c0 5.28 4.172 9.559 9.32 9.559.54-.001 1.08-.05 1.613-.147-.028.318-.045.64-.045.967 0 5.924 4.695 10.727 10.458 10.727 2.135 0 4.216-.667 5.954-1.91a7.657 7.657 0 0 0 5.056 1.91c4.314 0 7.812-3.6 7.812-8.013 0-.191-.013-.38-.027-.568h.027c4.62 0 8.365-3.842 8.365-8.586a8.607 8.607 0 0 0-4.551-7.648z",
    fill: "url(#license-management_svg__m)",
    transform: "matrix(-1 0 0 1 250.57 106.37)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313853",
    d: "M207.725 133.013a10.352 10.352 0 0 1-2.448-8.21 10.336 10.336 0 0 1 4.574-7.238 6.124 6.124 0 0 1-.975-3.323 5.889 5.889 0 0 1 5.022-5.979 5.877 5.877 0 0 1 6.519 4.286 8.73 8.73 0 0 1 7.508-4.349c4.847 0 8.776 4.03 8.776 9.002a9.192 9.192 0 0 1-.538 3.108c.176 0 .356-.027.538-.027 3.891 0 7.045 3.235 7.045 7.226 0 .247 0 .49-.036.729a8.98 8.98 0 0 1 5.29 8.243c0 4.955-3.915 8.974-8.748 8.974a8.539 8.539 0 0 1-1.513-.136c.025.3.042.601.042.906 0 5.562-4.394 10.068-9.815 10.068a9.61 9.61 0 0 1-5.59-1.794 7.191 7.191 0 0 1-4.746 1.794c-4.051 0-7.332-3.368-7.332-7.522 0-.18.014-.358.028-.535h-.028c-4.335 0-7.854-3.6-7.854-8.055a8.078 8.078 0 0 1 4.28-7.168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__n)",
    d: "M74.511 121.523h2.281v56.882h-2.281z",
    transform: "matrix(-1 0 0 1 300 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "M224.841 122.321h-1.146v56.084h1.146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "m224.942 138.838-9.411-10.194-.841.781 9.41 10.194zM234.624 141.2l-.683-.921-9.757 7.268.683.922z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.057 22.217a8.872 8.872 0 0 1-2.4-6.069 9.013 9.013 0 0 1 4.418-7.7 5.25 5.25 0 0 1-.92-2.964C5.156 2.51 7.642.1 10.713.1a5.526 5.526 0 0 1 5.332 3.879A8.334 8.334 0 0 1 23.134.1c4.573 0 8.284 3.602 8.284 8.033a7.754 7.754 0 0 1-.508 2.77c.169 0 .337-.025.508-.025 3.67 0 6.647 2.884 6.647 6.44 0 .218-.01.435-.033.651a7.998 7.998 0 0 1 4.99 7.349c0 4.417-3.695 7.999-8.254 7.999a8.55 8.55 0 0 1-1.428-.122c.025.277.04.535.04.809 0 4.955-4.143 8.974-9.263 8.974a9.42 9.42 0 0 1-5.274-1.598 7.017 7.017 0 0 1-4.482 1.587c-3.822 0-6.918-3.002-6.918-6.706 0-.16 0-.318.025-.476h-.025c-4.092 0-7.409-3.216-7.409-7.18a7.157 7.157 0 0 1 4.024-6.387z",
    fill: "url(#license-management_svg__o)",
    transform: "matrix(-1 0 0 1 224.887 117.172)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101938",
    d: "M220.082 139.359a8.51 8.51 0 0 0 2.298-5.817 8.625 8.625 0 0 0-4.217-7.37c.573-.835.88-1.824.881-2.837 0-2.847-2.38-5.155-5.318-5.155a5.3 5.3 0 0 0-5.104 3.71 7.974 7.974 0 0 0-6.785-3.71c-4.377 0-7.925 3.438-7.925 7.681 0 .906.164 1.804.486 2.65-.16 0-.32-.024-.486-.024-3.513 0-6.352 2.77-6.352 6.166 0 .208.012.416.034.623a7.657 7.657 0 0 0-4.778 7.032c0 4.227 3.538 7.656 7.9 7.656a8.21 8.21 0 0 0 1.382-.116c-.025.255-.04.512-.04.773 0 4.745 3.97 8.586 8.865 8.586a9.005 9.005 0 0 0 5.048-1.529 6.72 6.72 0 0 0 4.286 1.53c3.656 0 6.628-2.873 6.628-6.418 0-.153 0-.305-.025-.455h.025c3.915 0 7.091-3.077 7.091-6.872a6.846 6.846 0 0 0-3.894-6.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "M205.057 130.373v47.744"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__p)",
    d: "M93.603 130.373h2.593v47.741h-2.593z",
    transform: "matrix(-1 0 0 1 300 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "M205.772 130.373h-1.433v47.741h1.433zm-.861 14.301 8.5-8.697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "m213.923 136.481-1.024-1.006-8.5 8.697 1.024 1.006zM204.911 152.147l-8.812-6.202M205.32 151.554l-8.81-6.203-.824 1.178 8.811 6.201z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#101938",
    stroke: "#FFF",
    strokeWidth: 2.12,
    d: "M1.89 92.686h87.556v55.12H1.89z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(12.816 117.386)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.287,
    cy: 1.29,
    fill: "#FFF",
    rx: 1.287,
    ry: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M22.612 2.229H6.237a.938.938 0 0 1 0-1.877h16.375a.938.938 0 0 1 0 1.877z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M17.533 2.24H6.17a.948.948 0 0 1-.947-.95c0-.524.424-.95.947-.95h11.364c.523 0 .947.426.947.95 0 .525-.424.95-.947.95z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.287,
    cy: 6.922,
    fill: "#FFF",
    rx: 1.287,
    ry: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M22.612 7.86H6.237a.938.938 0 0 1 0-1.877h16.375a.938.938 0 0 1 0 1.877z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.287,
    cy: 18.053,
    fill: "#FFF",
    rx: 1.287,
    ry: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M22.612 18.992H6.237a.938.938 0 0 1 0-1.877h16.375a.938.938 0 0 1 0 1.877z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M13.79 19.003H6.17a.949.949 0 0 1-.001-1.9h7.621c.523 0 .947.426.947.95 0 .525-.424.95-.947.95z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.287,
    cy: 12.553,
    fill: "#FFF",
    rx: 1.287,
    ry: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M22.612 13.492H6.237a.938.938 0 0 1 0-1.878h16.375a.938.938 0 0 1 0 1.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M13.79 7.872H6.17a.95.95 0 0 1-.001-1.9h7.621c.523 0 .947.425.947.95 0 .524-.424.95-.947.95zm6.784 5.631H6.17a.948.948 0 0 1-.947-.95c0-.525.424-.95.947-.95h14.405c.523 0 .947.425.947.95 0 .525-.424.95-.947.95z"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 10.352,
    fontWeight: "bold",
    transform: "translate(.83 91.626)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.986,
    y: 19.347
  }, "STR")), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    opacity: 0.85,
    transform: "translate(46.967 108.726)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__q)",
    d: "M28.567 11.039H3.797c-.566 0-1.025.228-1.025.511v16.328h26.82V11.55c0-.283-.46-.511-1.025-.511z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.103 1.696 3.181 10.314v16.942h25.922V10.929z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.129,
    cy: 9.47,
    fill: "url(#license-management_svg__r)",
    rx: 2.877,
    ry: 2.584
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__s)",
    d: "M5.647 14.453h5.087v4.567H5.647zm15.774 0h5.087v4.567h-5.087z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__t)",
    d: "M.689 14.613 0 11.152 16.16 0l15.997 11.375-.444 3.105L16.158 3.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "m.721 13.918-.474-2.391L16.156.38 31.91 11.528l-.477 2.389L16.154 3.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__u)",
    d: "M12.995 19.62h6.217v7.636h-6.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M13.175 19.782h5.858v7.474h-5.858zm-7.296-5.168h4.727v1.5H5.879z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M5.879 16.114h4.727v2.745H5.879z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M21.601 14.614h4.727v1.5h-4.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M21.601 16.114h4.727v2.745h-4.727z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M16.103 11.8c.696 0 1.363-.248 1.854-.69.492-.442.768-1.041.767-1.665h-5.241c0 .624.275 1.223.767 1.665.491.442 1.158.69 1.853.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.103 11.777c1.448 0 2.62-1.054 2.62-2.353h-5.24c0 1.3 1.173 2.353 2.62 2.353z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M16.103 7.094c-1.446 0-2.619 1.052-2.62 2.35h5.24c0-1.298-1.173-2.35-2.62-2.35z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M16.103 7.094c-1.446 0-2.619 1.052-2.62 2.35h5.24c0-1.298-1.173-2.35-2.62-2.35z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.67,
    cy: 23.496,
    r: 1,
    fill: "url(#license-management_svg__v)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.67,
    cy: 23.496,
    r: 1,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__w)",
    d: "M12.224 26.171h7.553v2.214h-7.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.378 26.356h7.245v1.892h-7.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#license-management_svg__x)",
    d: "M23.427 6.273v-2.94h2.91v5.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M23.772 6.477V3.908h2.17v4.875z"
  })))));
};
export default SvgLicenseManagement;